import { IPartner } from 'clickNgo/entities/partner/models'

interface IRenderTableProperties {
  item: IPartner
  fieldName: string
  shouldRenderLink?: boolean
}

export const renderTableProperties = ({
  item,
  fieldName,
  shouldRenderLink,
}: IRenderTableProperties) => {
  const value = item[fieldName]

  if (value && shouldRenderLink) {
    return (
      <a href={value} target="_blank" rel="noreferrer">
        {value}
      </a>
    )
  }

  return <>{value || '-'}</>
}
